import { Component, OnDestroy } from "@angular/core";
import { ActivatedRouteSnapshot, NavigationEnd, Router } from "@angular/router";
import { MenuItem } from "primeng/api";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import { GblMenuModel, GeneralResModel } from "./_models";
import { AppMenuService, LocalStorageService } from "./_services";
import { BreadcrumbService } from "./breadcrumb.service";

interface Breadcrumb {
  label: string;
  url?: string;
}

@Component({
  selector: "app-breadcrumb",
  templateUrl: "./app.breadcrumb.component.html",
})
export class AppBreadcrumbComponent implements OnDestroy {
  subscription: Subscription;
  items: MenuItem[];

  private readonly _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([]);
  readonly breadcrumbs$ = this._breadcrumbs$.asObservable();
  docsUrl: string = "";
  menuItems: any[] = [];
  menuData: GblMenuModel[] = [];

  constructor(
    private router: Router,
    private _appMenuService: AppMenuService,
    public breadcrumbService: BreadcrumbService
  ) {
    this.menuItems = JSON.parse(localStorage.getItem("MENU") || "[]");
    this.subscription = breadcrumbService.itemsHandler.subscribe((response) => {
      this.items = response;
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const root = this.router.routerState.snapshot.root;
        const breadcrumbs: Breadcrumb[] = [];
        this.addBreadcrumb(root, [], breadcrumbs);

        this._breadcrumbs$.next(breadcrumbs);

        if (LocalStorageService.getUserStorageValue()) {
          this.getGblMenus();
        }
      });
  }

  private getGblMenus() {
    this._appMenuService
      .getGblMenus()
      .subscribe((res: GeneralResModel<GblMenuModel[]>) => {
        if (res.IsSucceed) {
          this.menuData = res.Result;

          if (this.menuData.length > 0) {
            this.updateDocsUrl();
          }
        }
      });
  }

  private updateDocsUrl() {
    const currentPath = this.router.url.split("?")[0];
    const matchedMenu = this.menuData.find(
      (item) =>
        item.MenuURL?.toLowerCase() === currentPath.toLowerCase() &&
        item.IsActiveDocs &&
        item.DocsUrl
    );

    if (matchedMenu) {
      this.docsUrl = matchedMenu.DocsUrl;
    } else {
      this.docsUrl = "";
    }
  }

  private addBreadcrumb(
    route: ActivatedRouteSnapshot,
    parentUrl: string[],
    breadcrumbs: Breadcrumb[]
  ) {
    const routeUrl = parentUrl.concat(route.url.map((url) => url.path));
    const breadcrumb = route.data["breadcrumb"];
    const parentBreadcrumb =
      route.parent && route.parent.data
        ? route.parent.data["breadcrumb"]
        : null;

    if (breadcrumb && breadcrumb !== parentBreadcrumb) {
      breadcrumbs.push({
        label: route.data["breadcrumb"],
        url: "/" + routeUrl.join("/"),
      });
    }

    if (route.firstChild) {
      this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
